import styled, { keyframes } from 'styled-components'

export const StyledTimer = styled.div`
    height: 5px;
    position: relative;
    background: #e37f7f;
    overflow: hidden;
    border-radius: 50px;
`

const transform = keyframes`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`

export const StyledProgressBar = styled.span`
    border-radius: 50px;
    display: block;
    height: 100%;
    background: #f3efe6;
    animation: ${transform} 15s reverse;
`
